import { render, staticRenderFns } from "./payment-type-view.vue?vue&type=template&id=2119b2e4&"
import script from "./payment-type-view.vue?vue&type=script&lang=js&"
export * from "./payment-type-view.vue?vue&type=script&lang=js&"
import style0 from "./payment-type-view.vue?vue&type=style&index=0&id=2119b2e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports